// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import {
  DefaultCopilotPromptInputProps,
  PlasmicCopilotPromptInput,
  PlasmicCopilotPromptInput__OverridesType,
} from "@/wab/client/plasmic/plasmic_kit_data_binding/PlasmicCopilotPromptInput";
import { HTMLElementRefOf } from "@plasmicapp/react-web";
import * as React from "react";

export type CopilotPromptInputProps = DefaultCopilotPromptInputProps &
  Pick<
    PlasmicCopilotPromptInput__OverridesType,
    | "imageUploadIcon"
    | "imageUploadContainer"
    | "runPromptBtn"
    | "textAreaInput"
    | "modelOverrideInput"
    | "systemPromptInput"
  >;

function CopilotPromptInput_(
  props: CopilotPromptInputProps,
  ref: HTMLElementRefOf<"div">
) {
  return <PlasmicCopilotPromptInput root={{ ref }} {...props} />;
}

export const CopilotPromptInput = React.forwardRef(CopilotPromptInput_);
